import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})

export class ErrorModalComponent {

  public message: string;

  constructor(public activeModal: NgbActiveModal) {
  };

}



// WEBPACK FOOTER //
// ./src/app/alert/error-modal.component.ts